export default __webpack_public_path__ + "static/MobileSizzle_V6 - Approved-5ad84f774c49c50e311e94b4b9b8a971.mp4";